module.exports = __webpack_public_path__ + "img/changeover.77f672bd.png";